import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-agent',
  templateUrl: './add-agent.component.html',
  styleUrls: ['./add-agent.component.css']
})
export class AddAgentComponent implements OnInit {

  constructor(private dbService: SqlService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal) { }

  Name = "";
  Surname = "";
  Cellnumber = "";
  Code = "";


  data = [
    {
      ID: "",
      Province: "",
      Active: "",
      DistributorsKey: "",
    }];
  Distributor = "";
  Distributors = [{ label: "", ID: "" }];

  Province = "";
  Provinces = [""];
  Areas = [{ label: '', ID: '' }];
  Area = '';

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    Swal.fire({
      title: 'Getting list of distributors',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.dbService.getAllDistrubutor().subscribe((ret: any) => {
      if (ret != "false") {
        this.Distributors.splice(0);
        this.Provinces.splice(0);
        this.data.splice(0);

        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")

          if (elementtemp[2] == "Yes") {
            let temp = {
              ID: elementtemp[0],
              Province: elementtemp[1],
              Active: elementtemp[2],
              DistributorsKey: elementtemp[3]
            }

            this.data.push(temp);
            if (!(this.Provinces.includes(elementtemp[1]))) {
              this.Provinces.push(elementtemp[1]);
            }
          }

        });
        Swal.close();
      } else {
        this.PopupTitle = "Something went wrong"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }


  ProvinceChanged() {
    this.Distributors.splice(0);
    this.data.forEach(element => {
      if (element.Province == this.Province) {
        this.Distributors.push({ label: element.ID, ID: element.DistributorsKey });
      }
    });
    // Load areas by province (returns Area, iUniqueAutoNumber pairs)
    this.Areas.splice(0);
    if (this.Province && this.Province !== '') {
      this.dbService.getAreasWithIdPerProvince(this.Province).subscribe((ret: any) => {
        if (ret != 'false') {
          let a = (ret as string).split(';');
          a.splice(a.length - 1, 1);
          a.forEach(element => {
            let elementtemp = element.split(',');
            this.Areas.push({ label: elementtemp[0], ID: elementtemp[1] });
          });
        }
      });
    }
  }


  async Save() {
  await (this.dbService.AddAgent(this.Name, this.Surname, this.Cellnumber, this.Code, this.Distributor, this.Area).subscribe((ret: any) => {
      if (!(String(ret).includes("Error"))) {
        this.PopupTitle = "Success"
        this.DisplayErrormessage = "The Agent has been added";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        this.Reset();
      } else {
        if ((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))) {
          this.PopupTitle = "Invalid Details"
          this.DisplayErrormessage = "This Agent already exists";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        } else {
          this.PopupTitle = "Something went wrong"
          this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        }

      }
    }));
  }

  Reset() {
    this.Name = "";
    this.Surname = "";
    this.Cellnumber = "";
    this.Code = "";
    this.Distributor = "";
    this.Province = "";
    this.Area = "";
  }

  Back() {
    this.router.navigate(['ViewAgent']);
  }



  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
